/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 04.08.17.
 */

import React from "react";
import PropTypes from "prop-types";
import {v4 as uuidv4} from "uuid";
import SubeditController from "./SubeditController";
import UiSchema from "../../../UiSchema";
import {PageAction} from "../../../services/PageAction/PageAction";

class SubnewController extends SubeditController {
    static propTypes = {
        basePath: PropTypes.string.isRequired,
        params: PropTypes.shape({
            path: PropTypes.string.isRequired,
            resource: PropTypes.string.isRequired,
            action: PropTypes.oneOf(["list","new","view","edit","delete"]).isRequired,
            id: PropTypes.string,
            query: PropTypes.object,
            tab: PropTypes.string,
            parentPath: PropTypes.string,
            parentResource: PropTypes.string,
            parentAction: PropTypes.oneOf(["list","new","view","edit","delete"]),
            parentId: PropTypes.string,
            parentField: PropTypes.string,
            parentTab: PropTypes.string,
            isModal: PropTypes.bool
        }).isRequired,
        schema: PropTypes.instanceOf(UiSchema).isRequired,
        location: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
        route: PropTypes.object.isRequired
    };

    static defaultProps = {};

    getNewUuid() {
        return "urn:uuid:" + uuidv4();
    }

    componentDidMount() {
        super.componentDidMount();
        this.actions().setEditRecord.defer({clientId: this.getNewUuid()}, false);
    }

    loadResource() {
    }

    /**
     *
     * @param {PageAction} action
     * @returns {boolean}
     */
    onAction(action) {
        switch (action.action) {
            case "subinsert":
                // Store data into parent record's datastore:
                this.saveToParent("insert");
                return true;
            default:
                break;
        }
        return super.onAction(action);
    }

}

export default SubnewController;
